import AREAS from './areas'
import CATEGORIA from './categoria'
import PRIORIDAD from './prioridad'

export class AltaPersonalNotification {
  #notification

  constructor(notification) {
    this.#notification = notification
  }

  create(args) {
    const notification = new this.#notification()
    notification.responsable = args.responsable
    notification.afectado = args.afectado
    notification.titulo = AREAS.RECURSOS_HUMANOS + ': Alta de personal'
    notification.mensaje = args.mensaje
    notification.prioridad = PRIORIDAD.MEDIA
    notification.categoria = CATEGORIA.INFORMATIVA

    return notification
  }
}
